module.exports = __webpack_public_path__ + "img/logo_login.de693c19.png";